export default "__VITE_ASSET__42b60a3f__"